// Partenaires historiquement codés en dur sur le site.
// Sert de liste de secours à PartnersSection tant que la collection
// Firestore `partners` est vide.
import brokerImg from "../components/MainContent/assets/partners/broker.png";
import madImg from "../components/MainContent/assets/partners/madfilms.png";
import euzhanImg from "../components/MainContent/assets/partners/euzhan.png";
import lifiseImg from "../components/MainContent/assets/partners/lifise.png";
import factoryImg from "../components/MainContent/assets/partners/factory.png";
import youareImg from "../components/MainContent/assets/partners/youare.svg";

export const DEFAULT_PARTNERS = [
  {
    name: "BROKER DEFENSE",
    logo: brokerImg,
    logoFileName: "broker.png",
    desc_fr: "Résolution des litiges financiers et victimes d'escroqueries",
    desc_en: "Financial dispute resolution and fraud victim assistance",
  },
  {
    name: "MAD FILMS",
    logo: madImg,
    logoFileName: "madfilms.png",
    desc_fr: "Société de production audiovisuelle française",
    desc_en: "French audiovisual production company",
  },
  {
    name: "EUZHAN PALCY",
    logo: euzhanImg,
    logoFileName: "euzhan.png",
    desc_fr: "Réalisatrice Oscarisée. Membre de l'Académie des Oscars.",
    desc_en:
      "Oscar-winning director. Member of the Academy of Motion Picture Arts and Sciences.",
  },
  {
    name: "LIFISE",
    logo: lifiseImg,
    logoFileName: "lifise.png",
    desc_fr: "Première néo-banque française Web3 grand public",
    desc_en: "First French mainstream Web3 neobank",
  },
  {
    name: "FACTORY CLUB",
    logo: factoryImg,
    logoFileName: "factory.png",
    desc_fr: "Accompagnement des sportifs professionnels.",
    desc_en: "Support for professional athletes.",
  },
  {
    name: "YOU ARE CAPITAL",
    logo: youareImg,
    logoFileName: "youare.svg",
    desc_fr: "Société internationale de conseil en Corporate Finance",
    desc_en: "International Corporate Finance consulting firm",
  },
];
